import MarketingBudget from './MarketingBudget';
import BudgetSummary from './budget-summary/BudgetSummary';

const MarketingBudgetConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/marketingBudget',
      element: <MarketingBudget />,
    },
    {
      path: '/marketingBudget/budget-summary',
      element: <BudgetSummary />,
    },
  ],
};

export default MarketingBudgetConfig;
